export const handleEnter = (key: string, cb: () => void) => {
  if (key === 'Enter') {
    cb()
  }
}
